import VideoCard from "../../components/common/VideoCard";
import { useLocation } from "react-router-dom";
import useSelectVideo from "../../hooks/useSelectVideo";

export default function Posts(props) {
    const { posts = [], loading } = props;
    const filterData = posts?.filter((item) => item.video_url !== null);

    const selectVideo = useSelectVideo();
    const location = useLocation();

    const handleSelectVideo = async (id) => {
        selectVideo(id, filterData, location.pathname, 'posts');
    };

    return (
        <>
            <div className="grid grid-cols-3 gap-1 overflow-scroll no-scrollbar px-2">
                {filterData?.map((data) => (
                    <VideoCard
                        id={data.id}
                        body={data.body}
                        belowDecs={true}
                        threeDots={false}
                        video={data.video_url}
                        view_count={data.view_count}
                        likes_count={data.likes_count}
                        authorId={data.created_by?.id}
                        selectVideo={handleSelectVideo}
                        avatar_url={data.created_by.avatar_url}
                    />
                ))}
            </div>
            {filterData.length === 0 && !loading && (
                <div className="flex justify-center items-center h-[25vh]">
                    <p className="text-[12px] text-gray-500">
                        No post found
                    </p>
                </div>
            )}
        </>
    );
}
